import React, { useEffect, useState } from "react";
import "./css/what-you-get.css";
import { Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const WhatYouGet = () => {
  const [content, setContent] = useState({
    titleLine1: "في نبض كير نجعل رحلة منتجك إلى السوق",
    titleLine2: "أكثر سلاسة ونجاحاً",
    descriptionText:
      "نحن في نبض كير لا نقدم مجرد استشارات، بل نمنحك راحة البال من خلال ضمان الامتثال الكامل وتسريع الإجراءات الحكومية المعقدة.",
    ctaLabel: "ابدأ رحلتك الآن",
    ctaPath: "/contact",
    stats: [
      { number: "98%", label: "نسبة قبول الملفات" },
      { number: "500+", label: "عميل نالوا ثقتنا" },
      { number: "100%", label: "امتثال للأنظمة" },
      { number: "24/7", label: "دعم فني مستمر" },
    ],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/what-you-get`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.whatYouGet) {
          setContent((prev) => ({
            ...prev,
            ...data.whatYouGet,
          }));
        }
      } catch {
        // fall back to defaults
      }
    };

    fetchData();
  }, []);

  const { titleLine1, titleLine2, descriptionText, ctaLabel, ctaPath, stats } = content;
  const statsList = Array.isArray(stats) ? stats : [];

  return (
    <>
      <section className="what-you-get-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {/* The Bracketed Content Frame */}
              <div className="border-frame">
                <h2 className="what-you-get-title">
                  {titleLine1}
                  <br />
                  {titleLine2}
                </h2>
                <p className="what-you-get-desc">{descriptionText}</p>

                <div className="cta-btn-wrapper">
                  {ctaLabel && ctaPath && (
                    <Link to={ctaPath} className="cta-main-btn">
                      {ctaLabel}
                      <i className="fa-solid fa-arrow-left"></i>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The Overlapping Stats Cards */}
      <div className="stats-overlap-container">
        <div className="container">
          <div className="row">
            {statsList.map((stat, index) => (
              <div key={`${stat.label}-${index}`} className="col-lg-3 col-md-6 col-sm-12">
                <div className="impact-card">
                  <h3>{stat.number}</h3>
                  <p>{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WhatYouGet;